import React, { useEffect, useState } from 'react';
interface Props {
  variant?: 'hero' | 'pricing' | 'final';
}
export function CountdownTimer({
  variant = 'hero'
}: Props) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 27,
    seconds: 4
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const isFinal = variant === 'final';
  const boxBg = isFinal ? 'bg-navy' : 'bg-sage';
  const numColor = 'text-gold';
  const labelColor = isFinal ? 'text-cream-white/60' : 'text-cream-white/60';
  const fontClass = isFinal ? 'font-display text-[48px] md:text-[64px]' : 'font-sans text-3xl md:text-4xl';
  return <div className="flex justify-center gap-4 md:gap-6" data-id="element-169">
      {[{
      val: timeLeft.hours,
      label: 'h'
    }, {
      val: timeLeft.minutes,
      label: 'm'
    }, {
      val: timeLeft.seconds,
      label: 's'
    }].map((item, i) => <div key={i} className="flex flex-col items-center" data-id="element-170">
          <div className={`${boxBg} ${numColor} ${fontClass} font-bold rounded-xl w-20 md:w-28 h-20 md:h-28 flex items-center justify-center shadow-lg`} data-id="element-171">
            {String(item.val).padStart(2, '0')}
          </div>
          <span className={`${labelColor} font-sans text-xs uppercase tracking-widest mt-2`} data-id="element-172">
            {item.label}
          </span>
        </div>)}
    </div>;
}